/* 
Uses functions and variables from asset files
- 'size-guide-functions.js'
*/
function loadSizeTablesPDP(brand) {
    let atLeastOneSizeChart = false;
    let sizeGuidePagesURL = {
        mens: `/pages/new-template-${brand}-mens-size-guide?view=blank`,
        womens: `/pages/new-template-${brand}-womens-size-guide?view=blank`,
        unisex: `/pages/new-template-${brand}-unisex-size-guide?view=blank`,
        kids: `/pages/new-template-${brand}-kids-size-guide?view=blank`,
    };

    Promise.all([fetch(sizeGuidePagesURL.mens), fetch(sizeGuidePagesURL.womens), fetch(sizeGuidePagesURL.unisex), fetch(sizeGuidePagesURL.kids)]) //Ajax call to get all the size pages.
    .then(function (responses) {
        return Promise.all(
            responses.map(function (response) {
                if (response.ok) {
                    atLeastOneSizeChart = true;
                    return response.text();
                }
            })
        );
    })
    .then((response) => {
        response.forEach(function (data, index) {
            try {
                parseAndAppendTable(data, __sizeGuideContainersId[index], false);
            } catch {
                console.log(`${__sizeGuideContainersId[index]} for ${brand} is unavailable.`);
            }
        });
        
        return;
    })
    .then(()=>{
        if (atLeastOneSizeChart){
            document.getElementById('size-chart').style.display = 'flex';
            document.getElementById('sizeChartModalOpener').style.display = 'block';
        }
    })
}

// Run functions 
if (typeof __productPdp !== "undefined" && __productPdp.vendor !== '' && __productPdp.isAccessory == 'false') {
    triggerCollapsibleTables();//Fnc in size-guide-functions.js
    loadSizeTablesPDP(__productPdp.vendor);
}